import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { AzureRdpAccesses } from "./accesses/azure.ts";
import { RdpComponents } from "./components.ts";

const RdpFilters = {
  admin: { keys: "boolean" },
  destination: {
    keys: ["full-resource-name", "name"],
    labeler: { name: "Instance name" },
  },
  region: { keys: ["id"], labeler: { id: "Region" } },
} as const satisfies AnyFilterSchema;

export type RdpFilters = typeof RdpFilters;

export const RdpRegistration = Registration({
  accesses: AzureRdpAccesses,
  category: "resource",
  components: RdpComponents,
  docs: {
    install: "rdp/installation",
    request: "rdp/requesting-access",
  },
  filters: RdpFilters,
  itemKind: "subscription",
  label: "Remote Desktop Protocol (RDP)",
  // This image is in the public domain See https://commons.wikimedia.org/wiki/File:Terminalicon2.png
  logoUrl:
    "https://upload.wikimedia.org/wikipedia/commons/7/75/RemoteDesktopManager-Icon-HR.png",
  maturity: "ga",
  requestType: "requestable",
  // TODO: Should map iam_write, but was copied from existing code that omitted this mapping
  useMapping: [],
});

registerIntegration("rdp", RdpRegistration);
